export default __webpack_public_path__ + "static/media/egyptFlag.dccb06ea.png";